// import components
import { styled, Box } from '@mui/material';

export const StyledNoteDeleteEntirePeriodBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.vars.palette.Alert.warningStandardBg,
  border: `1px solid ${theme.vars.palette.warning.fixedDim}`,
  borderRadius: theme.spacing(1)
}));
